/** @format */

import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { Dispatch } from 'react';
import { reducerGeneral } from '../../@ducks/general/reducer';
import { reducerBooking } from '../../@ducks/booking/reducer';
import { reducerFilters } from '../../@ducks/filters/reducer';
import { reducerSearch } from '../../@ducks/search/reducer';
import { watcherGeneral } from '../../@ducks/general/watcher';
import { TAction } from '../declarations';
import { TReducerBooking } from '../../@ducks/booking/selectors';
import { TReducerFilters } from '../../@ducks/filters/selectors';
import { TReducerSearch } from '../../@ducks/search/selectors';
import { TReducerGeneral } from '../../@ducks/general/selectors';

const middlewareSaga = createSagaMiddleware();

const reducers = combineReducers({
  general: reducerGeneral,
  booking: reducerBooking,
  search: reducerSearch,
  filters: reducerFilters,
});

export const configureStore = () => {
  const enhancer = composeWithDevTools(applyMiddleware(middlewareSaga));
  const store = createStore(reducers, {}, enhancer);
  middlewareSaga.run(watcherGeneral);

  return store;
};

export const store = configureStore();

export type TStore = {
  booking: TReducerBooking;
  general: TReducerGeneral;
  search: TReducerSearch;
  filters: TReducerFilters;
};

export type TDispatch = Dispatch<TAction>;
